import React from 'react';

const AppTypeContext = React.createContext();
export default AppTypeContext;
